var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeroMini',{attrs:{"msg":"Everyman Cycle","subMsg":"A short 3.5 hour sleep during the night, and Three 20 minute naps throughout the day."}}),_c('CycleCalculator',{attrs:{"msg":"Everyman Sleeping Cycle"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }